import React, { useState } from 'react'

//MUI
import { Box, Button, IconButton, Typography } from '@mui/material';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const months = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];
const days = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"];

const CalendarWidget = () => {
    const today = new Date();
    const [current, setCurrent] = useState(new Date(today.getFullYear(), today.getMonth(), 1));

    const year = current.getFullYear();
    const month = current.getMonth();

    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysInPrev = new Date(year, month, 0).getDate();
    const totalCells = 42;

    const cells = [];
    for (let i = 0; i < firstDay; i++) {
        cells.push({ day: daysInPrev - firstDay + i + 1, type: "prev" });
    }
    for (let d = 1; d <= daysInMonth; d++) {
        cells.push({ day: d, type: "current" });
    }
    const remaining = totalCells - cells.length;
    for (let i = 1; i <= remaining; i++) {
        cells.push({ day: i, type: "next" });
    }

    const isToday = (cell) =>
        cell.type === "current" &&
        cell.day === today.getDate() &&
        month === today.getMonth() &&
        year === today.getFullYear();

    const changeMonth = (dir) => {
        setCurrent(new Date(year, month + dir, 1));
    };

    return (
        <>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 16, color: "#1a2035" }}>
                    {months[month]} {year}
                </Typography>
                <Box sx={{ display: "flex", gap: 0.5, alignItems: 'center' }}>
                    <Button size='small' variant='outlined' sx={{ textTransform: 'none' }} onClick={() => { setCurrent(new Date(today.getFullYear(), today.getMonth(), 1)) }}>
                        Hoy
                    </Button>
                    <IconButton size="small" onClick={() => changeMonth(-1)}
                        sx={{
                            bgcolor: "#f0f3f8", borderRadius: 1.5, width: 28, height: 28,
                            "&:hover": { bgcolor: "#e3e8f5" },
                        }}
                    >
                        <ChevronLeftIcon sx={{ fontSize: 16, color: "#8892aa" }} />
                    </IconButton>
                    <IconButton size="small" onClick={() => changeMonth(1)}
                        sx={{
                            bgcolor: "#f0f3f8", borderRadius: 1.5, width: 28, height: 28,
                            "&:hover": { bgcolor: "#e3e8f5" },
                        }}
                    >
                        <ChevronRightIcon sx={{ fontSize: 16, color: "#8892aa" }} />
                    </IconButton>
                </Box>
            </Box>

            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", mb: 0.5 }}>
                {days.map((d) => (
                    <Typography key={d} align="center" sx={{ fontSize: 12, fontWeight: 600, color: "#8892aa", py: 0.5 }}>
                        {d}
                    </Typography>
                ))}
            </Box>

            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px" }}>
                {cells.map((cell, i) => (
                    <Box key={i}
                        sx={{
                            position: "relative", display: "flex", alignItems: "center", justifyContent: "center", py: "6px", borderRadius: 1.5, cursor: "pointer",
                            transition: "all 0.15s",
                            bgcolor: isToday(cell)
                                ? "linear-gradient(135deg, #3b6ff5, #6c4dff)"
                                : "transparent",
                            background: isToday(cell)
                                ? "linear-gradient(135deg, #3b6ff5, #6c4dff)"
                                : "transparent",
                            boxShadow: isToday(cell) ? "0 2px 8px rgba(59,111,245,0.35)" : "none",
                            "&:hover": {
                                bgcolor: !isToday(cell) ? "#fff" : undefined,
                            },
                        }}
                    >
                        <Typography sx={{ fontSize: 12, fontWeight: isToday(cell) ? 700 : 400, color: isToday(cell) ? "white" : cell.type !== "current" ? "#c5cad8" : "#1a2035" }}>
                            {cell.day}
                        </Typography>

                    </Box>
                ))}
            </Box>
        </>
    );
}

export default CalendarWidget;